import { Action } from "../../../actions/actions";
import { HistoryActionTypes } from "../actions/actionTypes";

export function activityLogs(
    state: { results: any[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case HistoryActionTypes.GET_ACTIVITY_SUCCESS:
            return action.payload.games;

        default:
            return state;
    }
}

export function currentActivitiesUsers(
    state: { results: any[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case HistoryActionTypes.GET_ACTIVITY_SUCCESS:
            return action.payload.users;
        default:
            return state;
    }
}

export function activityLogsLoading(state: boolean = true, action: Action) {
    switch (action.type) {
        case HistoryActionTypes.GET_ACTIVITY:
            return true;

        case HistoryActionTypes.GET_ACTIVITY_FAIL:
        case HistoryActionTypes.GET_ACTIVITY_SUCCESS:
            return false;

        default:
            return state;
    }
}
